// Argus — Helper-i pentru bulk operations din sidebar (multi-select agenți).
// Bloc ws-direct-batch-2 cleanup 2026-05-05: bulk screenshot folosește acum `wsClient.requestScreenshot`
// (WS direct, NO disk artifact). Imaginile NU se păstrează — fiecare bulk run e transient.

import { wsClient } from './wsClient';

export interface BulkActionResult {
  agentId: string;
  ok: boolean;
  error?: string;
}

/**
 * Emit screenshot WS direct pentru fiecare agent în paralel (Promise.allSettled).
 * Returnează array cu rezultat per agent — UI afișează count succes / eșec.
 * NU păstrăm PNG-urile (transient flow); pentru a vedea imagini, deschideți DesktopWindow per agent.
 */
export async function bulkScreenshot(agentIds: readonly string[]): Promise<BulkActionResult[]> {
  const results = await Promise.allSettled(
    agentIds.map(async (id) => {
      await wsClient.requestScreenshot(id, '');
    })
  );
  return results.map((r, i) => {
    const agentId = agentIds[i] ?? '';
    if (r.status === 'fulfilled') return { agentId, ok: true };
    const err = r.reason as Error;
    return { agentId, ok: false, error: err?.message ?? 'unknown' };
  });
}
